module.exports = __webpack_public_path__ + "c5c07f3ccba51af165c5577912f7205f.svg";